'use client'

import { usePathname } from 'next/navigation'
import React, { useEffect } from 'react'
import { atom, useRecoilState } from 'recoil'

export const pageTransitionDetectorState = atom<string[]>({
  key: 'pageTransitionDetector',
  default: [],
})

const PageTransitionDetector = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname()
  const [paths, setPaths] = useRecoilState(pageTransitionDetectorState)

  useEffect(() => {
    setPaths([...paths, pathname])
  }, [pathname])

  return children
}

export default PageTransitionDetector
